<template>
  <transition name="dialog-fade">
    <div class="el-dialog__wrapper" v-show="visible">
      <div ref="dialog">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
  name: 'nuttrema-dialog',
  mixins: [Dialog],
};
</script>



// WEBPACK FOOTER //
// src/components/ui/overlay/nuttrema-dialog.vue